import React, { Fragment, useState } from "react";
import LazyLoad from "react-lazyload";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import constructionImage from "./../../assets/img/collection-inner/parallax-img.png";

// Marquis Signature 
import marquisSignatureVideo from "./../../assets/sig-video.mp4";
import marquisSigImage1 from "./../../assets/sig-img1.jpg";
import marquisSigImage2 from "./../../assets/sig-img2.jpg";
import marquisSigImage3 from "./../../assets/sig-img3.jpg";
import marquisSigImage4 from "./../../assets/sig-img4.jpg";

// Marquis Elegance 
import marquisEleganceVideo from "./../../assets/Marquis-Elegance.mp4";

// Marquis Insignia 
import marquisInsigniaVideo from "./../../assets/Marquis-insignia-construction.mp4";

// Marquis Galleria 
import marquisGalleriaVideo from "./../../assets/Marquis-Galleria-construction.mp4";

import location_icon from "./../../assets/img/collection-inner/location.svg";
import price_icon from "./../../assets/img/collection-inner/dollar.svg";
import date_icon from "./../../assets/img/collection-inner/calendar.svg";
import building_icon from "./../../assets/img/collection-inner/building.svg";

import * as apiUrl from "../../apiUrl";

SwiperCore.use([Navigation, Autoplay, Pagination]);

function CollectionInnerConstruction({ lastImage, construction, slug }) {
  const [show, setShow] = useState(false);
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const path = location?.pathname || "";

  let slides = [];


  switch (path) {

    case "/collection-inner/marquis-signature":
      slides = [

        { type: "video", src: marquisSignatureVideo },
        { type: "image", src: marquisSigImage1 },
        { type: "image", src: marquisSigImage2 },
        { type: "image", src: marquisSigImage3 },
        { type: "image", src: marquisSigImage4 },

      ];
      break;

    case "/collection-inner/marquis-galleria":
      slides = [
        { type: "video", src: marquisGalleriaVideo },
      ];
      break;

    case "/collection-inner/marquis-insignia":
      slides = [
        { type: "video", src: marquisInsigniaVideo },
      ];
      break;

    case "/collection-inner/marquis-elegance":
      slides = [
        { type: "video", src: marquisEleganceVideo },
      ];
      break;


    case "/collection-inner/marquis-one":
    case "/collection-inner/marquis-vista":
    case "/collection-inner/2020-marquis":
      slides = [];
      break;

    default:
      slides = [];
      break;
  }


  const hasModalContent = slides.length > 0;

  return (
    <Fragment>
      <section className="collection-inner-construction-sec">
        <Container fluid>
          <Row className="flex-center">
            <Col md={12}>
              <div className="construction-parallax-sec">
                <Row className="banner-text-center">
                  <Col md={12}>
                    <div className="heading-div">
                      <h2 className="common-head darkGrey" data-aos="fade-up">
                        {construction.title}
                      </h2>
                    </div>
                  </Col>
                </Row>

                <div
                  className="main-card-layout-container-title-details"
                  data-aos="fade-up"
                >
                  <div className="main-card-layout-details-about">
                    <div className="card-main">
                      <div className="card-location-main-icon">
                        <img
                          src={location_icon}
                          className="img-fluid"
                          alt="1 bhk flat in dubai for sale"
                        />
                      </div>
                      <p className="card-main-text">{construction.place}</p>
                    </div>

                    <div className="card-main">
                      <div className="card-location-main-icon">
                        <img
                          src={date_icon}
                          className="img-fluid"
                          alt="one bedroom for sale in dubai"
                        />
                      </div>
                      <p className="card-main-text">{construction.year}</p>
                    </div>

                    <div className="card-main">
                      <div className="card-bedroom-main-icon">
                        <img
                          src={price_icon}
                          className="img-fluid"
                          alt="High ROI 3 bedroom apartment Dubai"
                        />
                      </div>
                      <p className="card-main-text">{construction.price}</p>
                    </div>

                    <div className="card-main">
                      <div className="card-bedroom-main-icon">
                        <img
                          src={building_icon}
                          className="img-fluid"
                          alt="Luxury studio apartment Dubai"
                        />
                      </div>
                      <p className="card-main-text green-highlight-color">
                        {construction.availablity}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="text-center" data-aos="fade-up">
                  <p className="common-para construction-text mb-3">
                    {construction.description}
                  </p>


                  {hasModalContent && (
                    <Link
                      className="marquis-grey-button mb-2"
                      onClick={handleShow}
                    >
                      View All
                    </Link>
                  )}

                  {lastImage && (
                    <img
                      src={`${apiUrl.apiUrl}/${lastImage}`}
                      className="img-fluid"
                      alt="New launch studio apartments Dubai"
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>


      {hasModalContent && (
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal-construction"
        >
          <Modal.Header closeButton className="modal-heading"></Modal.Header>
          <Modal.Body>
            <div className="modal-construction-swiper">
              <Swiper
                modules={[Navigation]}
                navigation={true}
                spaceBetween={40}
                slidesPerView={1}
                speed={1000}
                grabCursor={true}
                draggable={true}
                loop={false}
              >
                {slides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <div className="modal-construction-swiper-img">
                      {slide.type === "image" ? (
                        <img
                          src={slide.src}
                          className="img-fluid"
                          alt={`construction-slide-${index}`}
                        />
                      ) : (
                        <video
                          autoPlay
                          muted
                          loop
                          playsInline
                          className="bg-video"
                        >
                          <source src={slide.src} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </Fragment>
  );
}

export default CollectionInnerConstruction;
